// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import { useEffect, useRef } from 'react';

/**
 * Debounces localStorage writes to prevent high-frequency updates (e.g. during warp travel)
 * @param {string} key - localStorage key
 * @param {*} value - value to store (will be converted via .toString())
 * @param {number} delay - debounce delay in ms (default 2000)
 */
export function useDebouncedStorage(key, value, delay = 2000) {
  const timerRef = useRef(null);
  useEffect(() => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      localStorage.setItem(key, value.toString());
    }, delay);
    return () => clearTimeout(timerRef.current);
  }, [key, value, delay]);
}
